module.exports = __webpack_public_path__ + "img/levelup-background-element-light.3bcc4c04.svg";